import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  NavController,
  NavParams,
  LoadingController,
  ModalController,
  AlertController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ConfigProvider } from "src/app/services/config/config";
import { MdaProvider } from "src/app/services/mda/mda";
import { UserProvider } from "src/app/services/user/user";
import { CommonModule } from "@angular/common";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { format, parseISO, addDays, isAfter, isBefore, isEqual, differenceInMinutes } from "date-fns";
import { ProverDatepickerComponent } from "src/app/components/prover-datepicker/prover-datepicker";
import { ProverHorasComponent } from "src/app/components/prover-horas/prover-horas.component";

@Component({
  selector: "app-mda-encontro-remarcar",
  templateUrl: "./mda-encontro-remarcar.page.html",
  styleUrls: ["./mda-encontro-remarcar.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    DateFormatPipe,
    TranslateModule,
    ProverDatepickerComponent,
    ProverHorasComponent,
  ],
})
export class MdaEncontroRemarcarPage implements OnInit {
  dataFinal: any;
  public dateValue: any;
  isHoje: boolean = true;
  validations_form: FormGroup;
  hoje: any = format(new Date(), "yyyy-MM-dd");
  mda: any = { dadosMDA: { proximoEncontro: {} } };

  validation_messages = {
    data: [{ type: "required", message: this.translate.instant("A data deve ser informada") }],
    hora: [{ type: "required", message: this.translate.instant("A hora deve ser informada") }],
  };
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public mdaProvider: MdaProvider,
    public modalCtrl: ModalController,
    public formBuilder: FormBuilder,
    public userProvider: UserProvider,
    private translate: TranslateService,
    public alertCtrl: AlertController,
    public configProvider: ConfigProvider
  ) {
    this.mda = this.navParams.get("mda");

    this.dataFinal = format(
      addDays(parseISO(this.mda.dadosMDA.proximoEncontro.dataBase), this.mda.dadosMDA.frequenciaDias - 1),
      "yyyy-MM-dd"
    );

    const encontro = new Date(this.mda.dadosMDA.proximoEncontro.data);
    this.isHoje = !this.userProvider.hasConfig(100) ? true : differenceInMinutes(encontro, new Date()) > 24 * 60;

    this.validations_form = this.formBuilder.group({
      data: new FormControl(this.mda.dadosMDA.proximoEncontro.data.split(" ")[0], Validators.required),
      hora: new FormControl(this.mda.dadosMDA.proximoEncontro.data.split(" ")[1].substring(0, 5), Validators.required),
    });
  }

  ngOnInit() {
    this.date = this.mda.dadosMDA.proximoEncontro.dataBase;
  }

  get date(): any {
    return this.dateValue;
  }

  set date(value: string | Date) {
    this.dateValue = format(new Date(value), "yyyy-MM-dd");
  }

  async onSubmit(encontro: { data: any; hora: any }) {
    const dataEncontro = parseISO(encontro.data);
    const hoje = parseISO(this.hoje);
    const dataFinal = parseISO(this.dataFinal);

    const condicaoValida =
      ((isAfter(dataEncontro, hoje) || isEqual(dataEncontro, hoje)) &&
        (isBefore(dataEncontro, dataFinal) || isEqual(dataEncontro, dataFinal))) ||
      !this.mda.dadosMDA.frequenciaDias;

    !this.userProvider.hasConfig(100) || condicaoValida
      ? this.remarcar(encontro.data, encontro.hora, this.mda.dadosMDA.proximoEncontro.id)
      : this.alertDate();
  }

  async alertDate() {
    const alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Data Inválida!"),
      subHeader:
        this.translate.instant("O encontro pode ser remarcado entre as datas ") +
        format(parseISO(this.hoje), "dd/MM") +
        this.translate.instant(" até ") +
        format(parseISO(this.dataFinal), "dd/MM"),
      buttons: ["OK"],
    });

    alert.present();
  }

  public remarcar(data: any, hora: any, idEncontro: any) {
    this.mdaProvider.remarcar(idEncontro, data, hora).subscribe(async (data) => {
      await this.modalCtrl.dismiss({ acao: "remarcar" });
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
